// extracted by mini-css-extract-plugin
module.exports = {"container":"Drawer_container___RlFK","slide-up":"Drawer_slide-up__gfJj4"};